export default __webpack_public_path__ + "static/media/double-checkgray.4503c6d9.svg";